<template>
  <div class="landing-page-wrapper">
    <div class="landingpage-bg">
      <img
        class="img-landingpage-bg"
        src="../../../assets/img/landingpage-bg.png"
        alt=""
      />
    </div>
    <div class="landing-top-container">
      <div class="landing-logo">
        <img
          src="../../../assets/img/isupplier-logo.png"
          class="img-landing-logo"
          alt=""
        />
      </div>
      <div class="landing-logo">
        <img
          src="../../../assets/img/logo-smm.png"
          class="img-landing-smm-logo"
          alt=""
        />
      </div>
    </div>
    <div class="landing-container">
      <div class="landing-right">
        <div class="step-indicator">
          <div class="step-wrapper">
            <div
              :class="
                $store.state.kplhStore.activeLanding == 'register'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
              @click="jumpTo('register')"
            >
              1
            </div>
            <div class="step-hr-start"></div>
            <div class="step-name">Registrasi</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('profile')"
              :class="
                $store.state.kplhStore.activeLanding == 'profile'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              2
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Profil</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('grupah')"
              :class="
                $store.state.kplhStore.activeLanding == 'grupah'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              3
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Grup A - H</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('grupi1')"
              :class="
                $store.state.kplhStore.activeLanding == 'grupi1'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              4
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Grup I - 1</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('grupi2')"
              :class="
                $store.state.kplhStore.activeLanding == 'grupi2'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              5
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Grup I - 2</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('grupjm')"
              :class="
                $store.state.kplhStore.activeLanding == 'grupjm'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              6
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Grup J - M</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('selesai')"
              :class="
                $store.state.kplhStore.activeLanding == 'selesai'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              7
            </div>
            <div class="step-hr-end"></div>
            <div class="step-name">Selesai</div>
          </div>
        </div>
        <div class="landing-form">
          <div class="landing-box">
            <!-- <router-view /> -->
            <keep-alive>
              <component :is="activeLanding" />
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-footer-container">
      <span style="color:#fff; text-align:center"
        >Copyright© {{ new Date().getFullYear() }}
        <span style="color:#fff; font-weight:bold">Sinarmas Mining</span>. All
        Rights reserved</span
      >
    </div>
    <GlobalLoading
      v-if="
        $store.state.modalStore.isGlobalLoading ||
          $store.state.level1.isLoading ||
          $store.state.kplhStore.globalLoading
      "
    />
    <Notif v-if="$store.state.showModalNotif" />
  </div>
</template>
<script>
import { api, api_lp } from '@/services/config'
import axios from 'axios'
export default {
  name: 'instruction',
  data() {
    return {
      pick: '',
      errorMessage: null,
    }
  },
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
    Notif: () => import('@/components/modal/Notification.vue'),
  },
  async created() {
    const session = this.$route.params.session
    if (session) {
      await this.$store.commit('kplhStore/SET_KPLH_FORM', {
        name: 'is_vendor_feedback',
        value: true,
      })
    }
    this.setPage(session)
  },

  computed: {
    activeLanding: function() {
      const tab = this.$store.state.kplhStore.activeLanding

      switch (tab) {
        case 'register':
          return () => import('@/views/KPLH/register.vue')
          break
        case 'profile':
          return () => import('@/views/KPLH/profile.vue')
          break
        case 'grupah':
          return () => import('@/views/KPLH/grupAH.vue')
          break
        case 'grupi1':
          return () => import('@/views/KPLH/grupi1.vue')
          break
        case 'grupi2':
          return () => import('@/views/KPLH/grupi2.vue')
          break
        case 'grupjm':
          return () => import('@/views/KPLH/grupJM.vue')
          break
        case 'selesai':
          return () => import('@/views/KPLH/selesai.vue')
          break
        default:
          break
      }
    },
  },
  methods: {
    jumpTo(name) {
      const {
        register_step,
        profile_step,
        grupah_step,
        grupi1_step,
        grupi2_step,
        grupjm_step,
        end_step,
      } = this.$store.state.kplhStore

      if (name == 'register') {
        if (register_step) {
          this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'register' })
        } else {
          this.sendNotif()
        }
      }

      if (name == 'profile') {
        if (profile_step) {
          this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'profile' })
        } else {
          this.sendNotif()
        }
      }

      if (name == 'grupah') {
        if (grupah_step) {
          this.$store.commit('kplhStore/SET_ACTIVE_PAGE', {
            name: 'grupah',
          })
        } else {
          this.sendNotif()
        }
      }
      if (name == 'grupi1') {
        if (grupi1_step) {
          this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupi1' })
        } else {
          this.sendNotif()
        }
      }
      if (name == 'grupi2') {
        if (grupi2_step) {
          this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupi2' })
        } else {
          this.sendNotif()
        }
      }
      if (name == 'grupjm') {
        if (grupjm_step) {
          this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupjm' })
        } else {
          this.sendNotif()
        }
      }
      if (name == 'selesai' && end_step) {
        if (end_step) {
          this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'selesai' })
        } else {
          this.sendNotif()
        }
      }
    },
    sendNotif() {
      this.$store.commit(
        'SET_NOTIF',
        'Selesaikan Step Sebelumnya Terlebih Dahulu.'
      )
    },
    async setPage(query) {
      try {
        let url = `${api}/api/v1/request/session/${query}`

        let pendaftaran_id = null
        let bidang_usaha = ''
        let bidang_usaha_id = null
        let nama_vendor = ''
        let alamat = ''
        let type_pendaftaran_id = null
        let register_gems = null
        let register_bce = null
        let register_bkes = null
        let request_id = null
        let tujuan_pendaftaran_id = null
        let vendor_ref = null
        let is_vendor_done = false
        let is_sipm_validation = false

        const { data } = await axios({
          method: 'GET',
          url,
        })

        let dataStore = data.data
        console.log(
          '🚀 ~ file: index.vue ~ line 301 ~ setPage ~ dataStore',
          dataStore
        )

        if (data && data.status == 'success') {
          pendaftaran_id = dataStore && dataStore.id
          bidang_usaha =
            dataStore && dataStore.bidang_usaha_id == 1 ? 'bu' : 'perorangan'
          bidang_usaha_id = dataStore && dataStore.bidang_usaha_id
          type_pendaftaran_id = dataStore && dataStore.type_pendaftaran_id
          register_gems = dataStore && dataStore.register_gems
          register_bce = dataStore && dataStore.register_bce
          register_bkes = dataStore && dataStore.register_bkes
          nama_vendor = dataStore && dataStore.nama_vendor
          alamat = dataStore && dataStore.alamat
          request_id = dataStore && dataStore.request_id
          vendor_ref =
            dataStore && dataStore.request && dataStore.request.vendor_ref

          console.log('vendor_ref: ', vendor_ref)
          is_vendor_done =
            dataStore && dataStore.request && dataStore.request.status == 6
              ? false
              : true
          is_sipm_validation =
            dataStore && dataStore.request && dataStore.request.status == 8
              ? true
              : false
          tujuan_pendaftaran_id = this.$get(
            data,
            'data.request.tujuan_pendaftaran'
          )
          if (type_pendaftaran_id == 1) {
            this.$store.commit('kplhStore/SET_KPLH_FORM', {
              name: 'choosed_country',
              value: {
                id: 63,
                kode_negara: 'ID',
                negara: 'Indonesia',
                kode_telepon: '62',
                mata_uang: 'Rupiah ',
                kode_mata_uang: 'IDR',
                createdAt: '2021-12-07T07:15:27.000Z',
                updatedAt: '2021-12-07T07:15:27.000Z',
                deletedAt: null,
              },
            })
            this.$store.commit('kplhStore/SET_KPLH_FORM', {
              name: 'phone_code',
              value: '+62',
            })
            this.$store.commit('kplhStore/SET_KPLH_FORM', {
              name: 'kplh_pic_phone_code',
              value: '+62',
            })
          }

          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'request_id',
            value: request_id,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'is_vendor_feedback',
            value: true,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'is_vendor_done',
            value: is_vendor_done,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'is_sipm_validation',
            value: is_sipm_validation,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'vendor_ref',
            value: vendor_ref,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'pendaftaran_id',
            value: pendaftaran_id,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'tujuan_pendaftaran_id',
            value: tujuan_pendaftaran_id,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'bidang_usaha_id',
            value: bidang_usaha_id,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'type_pendaftaran_id',
            value: type_pendaftaran_id,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'vendor_name',
            value: nama_vendor,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'vendor_address',
            value: alamat,
          })
          await this.getInformasi(vendor_ref)
          await this.getKPLH(request_id)
          await this.getKplhPenilaian(request_id)
          await this.getKplhDoc(request_id)
          await this.getKBUG(request_id)
        }
      } catch (error) {
        console.log('error index kplh: ', error)
        await this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
        // await this.$router.push('/')
      }
    },
    async getInformasi(vendor_id) {
      const url = `${api}/api/v1/d-vendor-informasi?id=${vendor_id}`

      await this.$store.commit('kplhStore/SET_KPLH_FORM', {
        name: 'globalLoading',
        value: true,
      })
      await axios({
        method: 'GET',
        url,
      })
        .then(async ({ data }) => {
          let informasi = data.data
          console.log('informasi: ', informasi)
          this.$store.commit('kplhStore/UPDATE_INFORMASI', informasi)
        })
        .catch(error => {
          // do nothing
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },
    async getKBUG(id) {
      const url = `${api_lp}/api/v1/vendor/kbug/${id}`

      await this.$store.commit('kplhStore/SET_KPLH_FORM', {
        name: 'globalLoading',
        value: true,
      })

      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          let result = data.data
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'kbug_data',
            value: result,
          })
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          // do nothing
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },

    async getKPLH(id) {
      const url = `${api_lp}/api/v1/vendor/kplh-detail/${id}`

      await this.$store.commit('kplhStore/SET_KPLH_FORM', {
        name: 'globalLoading',
        value: true,
      })

      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 470 ~ .then ~ data',
            data
          )

          let result = data.data
          this.$store.commit('kplhStore/SET_KPLH_DETAIL', result)
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 469 ~ getParent ~ error',
            error
          )
          // do nothing
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },
    async getKplhPenilaian(id) {
      const url = `${api_lp}/api/v1/vendor/kplh-penilaian/${id}`

      await this.$store.commit('kplhStore/SET_KPLH_FORM', {
        name: 'globalLoading',
        value: true,
      })

      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 470 ~ .then ~ data',
            data
          )

          let result = data.data
          this.$store.commit('kplhStore/SET_UPDATE_PENILAIAN', result)
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 469 ~ getParent ~ error',
            error
          )
          // do nothing
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },
    async getKplhDoc(id) {
      const url = `${api_lp}/api/v1/vendor/kplh-doc/${id}`

      await this.$store.commit('kplhStore/SET_KPLH_FORM', {
        name: 'globalLoading',
        value: true,
      })

      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 470 ~ .then ~ data',
            data
          )

          let result = data.data
          this.$store.commit('kplhStore/SET_DOCUMENT_LIST', result)
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          console.log(
            '🚀 ~ file: sipm-view.vue ~ line 469 ~ getParent ~ error',
            error
          )
          // do nothing
          this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
        })
    },
  },
}
</script>
